// extracted by mini-css-extract-plugin
export default {"value":"pYJyJ___Metric-module__value"};